export default "__VITE_ASSET__75cd1bbc__"